import { updateDialog } from '@Containers/Dialogs/DialogsActions';

import { typeOfZeroFilterResults } from './ZeroFilterResultsConstants';

export function open() {
  return updateDialog({
    id: typeOfZeroFilterResults,
    movable: false,
    size: 'md',
    dialogType: typeOfZeroFilterResults,
  });
}
